import type { AppearanceMode } from '@shared/dark-mode-utils';

import {
    saveAppearanceMode as saveAppearanceModeReducerAction,
    useDarkModeState,
} from './darkModeSlice';
import { updateDarkModePreference } from './DarkModeService';

const DARK_MODE_CLASSNAME = 'g-dark';

type HookResult = {
    isActive: boolean;
    appearanceMode: AppearanceMode;
    saveAppearanceMode: (appearanceMode: AppearanceMode) => void;
    toggleOverride: (isToggleEnabled: boolean) => void;
};

export function useDarkMode(): HookResult {
    const { isActive, appearanceMode } = useDarkModeState();

    document.documentElement.classList.toggle(DARK_MODE_CLASSNAME, isActive);

    const saveAppearanceMode = (selectedAppearanceMode: AppearanceMode) => {
        saveAppearanceModeReducerAction(selectedAppearanceMode);
        updateDarkModePreference(selectedAppearanceMode);
    };

    const toggleOverride = (isToggleEnabled: boolean): void => {
        const overrideAppearanceMode = isToggleEnabled ? 'DARK' : 'LIGHT';
        saveAppearanceModeReducerAction(overrideAppearanceMode);
    };

    return {
        isActive,
        appearanceMode,
        saveAppearanceMode,
        toggleOverride,
    };
}
